<script>
    import Mobilebtn2 from '../mobilebtn2.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let img;
    let main;
    let title;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            img,
            [
                {scale: 1, y: '0vw', duration: 1},
                {scale: 1.63, y: '-21.626vw', duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            title,
            [
                {y: '0vw', duration: 1},
                {y: '0vw', duration: 1},
            ],
            3,
        );
    }
</script>

<div class="gamerWrraper" bind:this={main}>
    <div class="contentPosition" bind:this={title}>
        <div class="heading1">
            <p>STORY</p>
            <p>TELLERS</p>
        </div>
        <div class="text">
            <p>
                Turn your words into a living breathing world in the blink of an
                eye. Write scenes, characters and their dialogs and watch it
                happen in real time.
                <br /><br />
                Unleash your imagination and let our technology do the work.
            </p>
            <div class="btn">
                <a href="/story">
                    <Mobilebtn2
                    popup = false
                    bgcolor="transparent"
                    text="Learn More"
                    width="23.364vw"
                    height="7.477vw"
                    txtcolor="#F7FFC8"
                    border="#F7FFC8"
                    textPadding = '0vw'
                />
                </a>
            </div>
        </div>
    </div>
    <div class="imageWrraper" bind:this={img}>
        <img
            src="/images/storyteller.png"
            alt="storyTeller"
            width="100%"
            height="auto"
        />
    </div>
</div>

<style>
    .gamerWrraper {
        width: 100vw;
        overflow: hidden;
        position: relative;
        font-family: "Orbitron";
        background-color: #d578ff;
        height: max(216.355vw, 100vh);
    }
    p {
        margin: 0;
        font-family: "Orbitron";
    }
    .contentPosition {
        position: absolute;
        left: max(1.168vw, 0.54vh);
        top: max(32.215vw, 15.739vh);
        width: 100vw;
        transform: translateY(9.346vw);
    }
    .heading1 {
        color: #f7ffc8;
        font-weight: 900;
        font-size: max(11.682vw, 5.4vh);
    }
    .heading1 p:nth-child(2) {
        margin-left: max(10.2vw, 4.204vh);
    }
    .imageWrraper {
        bottom: 0;
        width: 100vw;
        position: absolute;
        transform: translate(0,-21.626vw);
        scale:1.63;
        height: max(110.047vw, 46.864vh);
    }
    .text {
        color: #f7ffc8;
        width: 83.411vw;
        letter-spacing: 0.06em;
        font-size: 2.804vw;
        margin: auto;
        line-height: 3.897vw;
    }
    .btn {
        float: right;
        margin-top: 4vw;
    }
</style>
